<template>
  <div class="c_wrapper c_related_customer_stories">
    <div class="c_related_customer_stories__section_title" v-if="sectionTitle">
      <h2 class="c_2022--body">{{ sectionTitle }}</h2>
    </div>
    <client-only v-if="!showSlider">
      <div class="c_related_customer_stories--noslider">
        <RelatedCustomerStory
          v-for="(story, index) in stories"
          :key="index"
          :location="story.location"
          :secondary-title="story.customerStorySecondaryTitle"
          :secondary-description="story.customerStorySecondaryDescription"
          :title="story.cardTitle"
          :description="story.cardDescription"
          :link="story.uri"
        />
      </div>
    </client-only>
    <client-only v-if="showSlider">
      <div class="c_related_customer_stories__grid c_agile_slider_2022">
        <agile @after-change="getCurrentSlide($event)" :options="agileOptions">
          <RelatedCustomerStory
            v-for="(story, index) in stories"
            :key="index"
            :location="story.location"
            :secondary-title="story.customerStorySecondaryTitle"
            :secondary-description="story.customerStorySecondaryDescription"
            :title="story.cardTitle"
            :description="story.cardDescription"
            :link="story.uri"
          />
        </agile>
        <mq-layout mq="sm">
          <SlideNumbers :number-of-slides="getNumberOfSlides" :current-slide="currentSlide" />
        </mq-layout>
      </div>
    </client-only>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile';
import SlideNumbers from 'Components/slider/SlideNumbers.vue';
import RelatedCustomerStory from './RelatedCustomerStory.vue';

export default {
  props: {
    stories: Array,
    sectionTitle: String,
  },
  data() {
    return {
      currentSlide: null,
      mqSmall: 850,
      mqMedium: 1300,
      mq: null,
      agileOptions: {
        infinite: true,
        slidesToShow: 3,
        navButtons: true,
        dots: false,
      },
    };
  },
  components: {
    agile: VueAgile,
    SlideNumbers,
    RelatedCustomerStory,
  },
  methods: {
    getCurrentSlide(e) {
      return (this.currentSlide = e.currentSlide + 1);
    },
    getWindowDimensions() {
      if (typeof window !== 'undefined') {
        this.mq = document?.documentElement.clientWidth;
        if (this.mq < this.mqSmall) {
          this.agileOptions.slidesToShow = 1;
        } else if (this.mq < this.mqMedium && this.mq > this.mqSmall) {
          this.agileOptions.slidesToShow = 2;
        } else {
          this.agileOptions.slidesToShow = 3;
        }
      }
    },
  },
  computed: {
    getNumberOfSlides() {
      return this.stories.length;
    },
    showSlider() {
      if (
        (this.stories.length > 1 && this.mq < this.mqSmall) ||
        this.stories.length > 3 ||
        (this.stories.length === 3 && this.mq < this.mqMedium)
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    window.addEventListener('resize', this.getWindowDimensions);
  },
  unmounted() {
    window.removeEventListener('resize', this.getWindowDimensions);
  },
  created() {
    this.getWindowDimensions();
  },
};
</script>

<style lang="scss">
.c_related_customer_stories {
  $self: &;
  padding-right: px_to_rem(40);
  padding-bottom: px_to_rem(40);
  padding-left: px_to_rem(40);
  @include mq($mq_sm_to_md) {
    padding-right: px_to_rem(100);
    padding-bottom: px_to_rem(100);
    padding-left: px_to_rem(100);
  }
  @at-root #{&}__section_title {
    display: flex;
    justify-content: center;
    h2 {
      background-color: $color_gray_240;
      @include font('graphik_medium');
      padding: px_to_rem(20) px_to_rem(35);
      text-align: center;
      margin-bottom: px_to_rem(40);
      @include mq($mq_sm_to_md) {
        margin-bottom: px_to_rem(70);
      }
    }
  }
}
.c_related_customer_stories--noslider {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
  grid-column-gap: px_to_rem(15);
}
</style>
